import React from 'react';

import { athenaUrl } from '../../helpers';
import styles from './AthenaLink.module.scss';

const AthenaLink = ({ patient }) => {
  if (!patient) return null;

  const href = athenaUrl(patient.athenaId);
  const hasLink = Boolean(href);
  const mrn = patient.mrn ?? '—';

  return (
    <a
      className={`${styles.link} ${hasLink ? '' : styles.disabled}`}
      href={href}
      target={hasLink ? '_blank' : undefined}
      rel={hasLink ? 'noopener noreferrer' : undefined}
      aria-disabled={!hasLink}
      onClick={(e) => {
        if (!hasLink) e.preventDefault();
      }}
    >
      <div className={styles.badge}>
        <span className={styles.badgeText}>A</span>
      </div>
      <div className={styles.meta}>
        <span className={styles.title}>Open in Athena</span>
        <span className={styles.mrn}>{mrn}</span>
      </div>
      <span className={styles.arrow} aria-hidden="true">
        ↗
      </span>
    </a>
  );
};

export default AthenaLink;
